module.exports = __webpack_public_path__ + "static/img/16.f8dc154.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/16.png
// module id = hjW0
// module chunks = 0